var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"amount-chip",class:_vm.contentClass,attrs:{"id":_vm.id}},[_c('div',{staticClass:"prepend"},[_vm._t("prepend")],2),_c('div',{staticClass:"amount"},[_vm._t("amount")],2),_c('div',{staticClass:"append"},[_vm._t("append")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }